import { IconProps } from "@/types/icons";

export const Image = ({
  width = 21,
  height = 21,
  className,
  decorative = false,
  ariaLabel = "Immagine",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7667 1.23854H1.89999V19.1052H19.7667V1.23854ZM0.833328 0.171875V20.1719H20.8333V0.171875H0.833328Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8333 7.5941C14.5815 7.5941 14.3444 7.71265 14.1933 7.9141L11.26 11.8252C11.1672 11.9489 11.0254 12.0262 10.8711 12.0372C10.7169 12.0482 10.5655 11.9917 10.4562 11.8823L9.54332 10.9694C9.3793 10.8054 9.15214 10.7206 8.92076 10.7371C8.68939 10.7536 8.47655 10.8697 8.33743 11.0553C8.33209 11.0624 8.32657 11.0694 8.32088 11.0763L5.12494 14.9229L4.30449 14.2413L7.49262 10.404C7.81736 9.97765 8.30993 9.71123 8.845 9.67313C9.38488 9.63469 9.91486 9.83247 10.2976 10.2152L10.7756 10.6933L13.34 7.2741C13.6925 6.80406 14.2458 6.52743 14.8333 6.52743C15.4209 6.52743 15.9741 6.80406 16.3267 7.2741L19.02 10.8652L18.1667 11.5052L15.4733 7.9141C15.3222 7.71265 15.0851 7.5941 14.8333 7.5941Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.63333 5.17188C3.63333 3.95685 4.6183 2.97188 5.83333 2.97188C7.04835 2.97188 8.03333 3.95685 8.03333 5.17188C8.03333 6.3869 7.04835 7.37188 5.83333 7.37188C4.6183 7.37188 3.63333 6.3869 3.63333 5.17188ZM5.83333 4.03854C5.20741 4.03854 4.7 4.54595 4.7 5.17188C4.7 5.7978 5.20741 6.30521 5.83333 6.30521C6.45925 6.30521 6.96666 5.7978 6.96666 5.17188C6.96666 4.54595 6.45925 4.03854 5.83333 4.03854Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.41111 14.083H20.2556V15.1497H1.41111V14.083Z"
        fill="white"
      />
    </svg>
  );
};
